import { all, put, race, select, take, takeEvery } from 'redux-saga/effects'
import { startSubmit, stopSubmit } from 'redux-form'
import { SUCCESS, FAILED } from 'crom-api-constants'

import { FORM_ID, SUBMIT_USER_DATA_FORM, UPDATE_USER_DATA_REQUEST, RELOAD_UPDATE_USER_DATA_REQUEST } from './constants'

import { updateUserDataRequest, reloadUserInfoRequest } from './actions'
import { showLoader, hideLoader } from '../../../Loader/actions'

import { sessionIdSelector } from './selectors'

const UPDATE_USER_DATA_REQUEST_SUCCESS = `${UPDATE_USER_DATA_REQUEST}_${SUCCESS}`
const UPDATE_USER_DATA_REQUEST_FAILED = `${UPDATE_USER_DATA_REQUEST}_${FAILED}`

const RELOAD_UPDATE_USER_DATA_REQUEST_SUCCESS = `${RELOAD_UPDATE_USER_DATA_REQUEST}_${SUCCESS}`
const RELOAD_UPDATE_USER_DATA_REQUEST_FAILED = `${RELOAD_UPDATE_USER_DATA_REQUEST}_${FAILED}`

function* handleUpdateProfile(_action) {
    const contentId = _action.data.contentId || null
    const firstName = _action.data.values.get('firstName', '')
    const lastName = _action.data.values.get('lastName', '')
    const email = _action.data.values.get('email', '')

    if (!contentId) return null

    yield put(startSubmit(FORM_ID))
    yield put(showLoader(contentId))

    const sessionId = yield select(sessionIdSelector)

    // update data
    const resultUpdate = yield all({
        response: race({
            success: take(UPDATE_USER_DATA_REQUEST_SUCCESS),
            failed: take(UPDATE_USER_DATA_REQUEST_FAILED),
        }),
        request: put(updateUserDataRequest(sessionId, firstName, lastName, email)),
    })

    // reload data for redux store (update return empty response)
    const resultReload = yield all({
        response: race({
            success: take(RELOAD_UPDATE_USER_DATA_REQUEST_SUCCESS),
            failed: take(RELOAD_UPDATE_USER_DATA_REQUEST_FAILED),
        }),
        request: put(reloadUserInfoRequest(sessionId)),
    })

    if (resultUpdate.response.success && resultReload.response.success) {
        yield put(stopSubmit(FORM_ID))
    } else {
        yield put(stopSubmit(FORM_ID, { _error: 'async' }))
    }

    yield put(hideLoader(contentId))

    return null
}

export default function* editProfileFormSaga() {
    yield all([takeEvery(SUBMIT_USER_DATA_FORM, handleUpdateProfile)])
}
